import { render, staticRenderFns } from "./Photobox.vue?vue&type=template&id=1546d2d8&lang=html&"
import script from "./Photobox.vue?vue&type=script&lang=js&"
export * from "./Photobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports